import { PaymentOptionDto } from "@api-types/payment-options/PaymentOptionDto";

export class PaymentOptionsData {
	depositList: PaymentOptionDto[];
	withdrawList: PaymentOptionDto[];
}
